import { getJdiOSFile } from '@/util';
import { getJdiosWebpImageUrl } from '@/util/getImg';
import defaultLogo from '@/assets/images/common/logo.png'

/** 全站默认 Header/Footer 工采 Logo（jdios） */
export const HEADER_LOGO_JDIOS_PATH = 'mubla1/100745181716976406.png';

/**
 * 默认 Logo 直出 PNG：索引色小图 fmt/webp 实测 ~7.5KB > 原图 ~4.3KB，转 WebP 反而变大。
 */
export const HEADER_LOGO_IMAGE_URL = defaultLogo;

/** Nav 动态 logo：默认工采图走原图，客户自定义 logo 仍尝试 WebP */
export function resolveNavLogoImageUrl(logoUrl?: string | null): string {
  const source = logoUrl?.trim() || '';
  if (!source) {
    return '';
  }

  if (source.includes(HEADER_LOGO_JDIOS_PATH)) {
    return source.startsWith('http') ? source : HEADER_LOGO_IMAGE_URL;
  }

  return getJdiosWebpImageUrl(source);
}
